import PainterProxy from '../painter/proxy';
import { store } from '@/store';
import cursorPen from '../../assets/art/cursor/cursor_pen.png'
import cursorPenlight from '../../assets/art/cursor/cursor_penlight.png'
import cursorLaserPointer from '../../assets/art/cursor/cursor_laser_pointer.png'
import cursorEraser from '../../assets/art/cursor/cursor_eraser.png'
import cursorZoomPart from '../../assets/art/cursor/cursor_zoom_part.png'
import cursorSticker from '../../assets/art/cursor/cursor_sticker.png'
import cursorTextBox from '../../assets/art/cursor/cursor_text_box.png'
import cursorWebLink from '../../assets/art/cursor/cursor_web_link.png'
import cursorInsertPicture from '../../assets/art/cursor/cursor_insert_picture.png'
import cursorStamp from '../../assets/art/cursor/cursor_stamp.png'
import cursorGraphicBoard from '../../assets/art/cursor/cursor_graphic_board.png';
import { TOOLS } from '../toolbar/tools';

export default class CursorStyle {
    instance = null;

    tempCursor = "";

    tempCursorList = ["pointer"];

    constructor() { }

    static getInstance() {
        if (!CursorStyle.instance) {
            CursorStyle.instance = new CursorStyle();
        }
        return CursorStyle.instance;
    }

    changeCursor(cursor) {
        PainterProxy.getInstance().changeCursor(cursor);
    }

    setCurrentCursor() {
        switch (store.nowTool) {
            case TOOLS.SELECTION.TOOL:
                this.setCursorDefault();
                break;
            case TOOLS.PEN.TOOL:
                this.setCursorPen();
                break;
            case TOOLS.HIGHLIGHTER.TOOL:
                this.setCursorPenlight();
                break;
            case TOOLS.LASER_POINTER.TOOL:
                this.setCursorLaserPointer();
                break;
            case TOOLS.ERASER.TOOL:
                this.setCursorEraser();
                break;
            case TOOLS.ZOOM_PART.TOOL:
                this.setCursorZoomPart();
                break;
            case TOOLS.TEXT_TIP.TOOL:
                this.setCursorSticker();
                break;
            case TOOLS.TEXT_BOX.TOOL:
                this.setCursorTextBox();
                break;
            case TOOLS.WEBLINK.TOOL:
                this.setCursorWebLink();
                break;
            case TOOLS.IMAGE.TOOL:
                this.setCursorInsertPicture();
                break;
            case TOOLS.STAMP.TOOL:
                this.setCursorStamp();
                break;
            case TOOLS.GRAPHIC_BOARD.TOOL:
                this.setCursorPaintBoard();
                break;
            default:
                this.setCursorDefault();
                break;
        }
    }

    setCursorDefault() {
        this.changeCursor("");
    }

    setCursorPointer() {
        this.changeCursor("pointer");
    }

    setCursorPen() {
        this.changeCursor(`url(${cursorPen}) 5 2, auto`);
    }

    setCursorPenlight() {
        this.changeCursor(`url(${cursorPenlight}) 5 3, auto`);
    }

    setCursorLaserPointer() {
        this.changeCursor(`url(${cursorLaserPointer}) 5 3, auto`);
    }

    setCursorEraser() {
        this.changeCursor(`url(${cursorEraser}) 0 0, auto`);
    }

    setCursorZoomPart() {
        this.changeCursor(`url(${cursorZoomPart}) 0 0, auto`);
    }

    setCursorSticker() {
        this.changeCursor(`url(${cursorSticker}) 0 0, auto`);
    }

    setCursorTextBox() {
        this.changeCursor(`url(${cursorTextBox}) 0 0, auto`);
    }

    setCursorWebLink() {
        this.changeCursor(`url(${cursorWebLink}) 0 0, auto`);
    }

    setCursorInsertPicture() {
        this.changeCursor(`url(${cursorInsertPicture}) 0 0, auto`);
    }
    
    setCursorStamp() {
        this.changeCursor(`url(${cursorStamp}) 18 18, auto`);
    }
    
    setCursorPaintBoard() {
        this.changeCursor(`url(${cursorGraphicBoard}) 0 0, auto`);
    }
}